export default __webpack_public_path__ + "static/media/landing2.904f975d.png";